const CheckoutActions = require("../actions/checkout");
const CroquisActions = require("../actions/croquis");
const PromoCode = require("../actions/promocodes");

module.exports = store => {
    store.dispatch(CheckoutActions.fetchPurchaseOptions());
    store.dispatch(CheckoutActions.fetchDownloadPackages());
    store.dispatch(CroquisActions.fetchRenderingOptions());
};



// WEBPACK FOOTER //
// ./src/initializers/fetch-data.js